import { getQueryParam } from '../../../utils/url-helpers'
import { _scrollTo } from '../../../utils/domHelpers'
import LiveInputs from '@app/application/reconciliation/handlers/live_inputs'

const LIQUID_PATH_URL_PARAM = 'focused_liquid_path'

// focus only on TL load. onDomLoad calls this unnecessarily e.g. after saving a(nother) TP.
$(document).on('turbolinks:load', () => {
  const liquidPath = getQueryParam(LIQUID_PATH_URL_PARAM)

  let field = document.querySelector(`[data-name="${liquidPath}"]`)
  const isCheckbox = field && field.classList.contains('sf-hidden')

  if (isCheckbox) {
    field = field.parentElement.querySelector('.sf-form-check-content')
  }

  if (!field) return

  let retries = 0

  const timer = setInterval(async () => {
    try {
      // we need to wait until LiveInputs are initialized,
      // so that focusing the field will also display the LiveInput icons
      if (LiveInputs.initialized) {
        _scrollTo(field)

        if (!isCheckbox) {
          window.eventHub.$emit('focus-live-input', field)
        }

        if (field.setSelectionRange) {
          const fieldTextSize = field.value.length
          field.setSelectionRange(fieldTextSize, fieldTextSize)
        }

        clearInterval(timer)
      }
      retries += 1
      // avoid infinitely executing this if something goes wrong with the LiveInputs
      if (retries > 5) {
        clearInterval(timer)
      }
    } catch (e) {
      clearInterval(timer)
    }
  }, 200)
})
